declare global {
    interface Window {
        REACT_APP_API_DOMAIN: string;
        REACT_APP_WS_URL: string;
        REACT_APP_ALLOWED_DOMAINS: string;
        REACT_APP_USER_API_DOMAIN: string;
        REACT_APP_COMPONENT_API_DOMAIN: string;
        REACT_APP_ENV: string;
        REACT_APP_SERVICE_PREFIX: string;
        REACT_APP_DEFAULT_LANG: string;
    }
}

/** Bỏ dấu "/" cuối domain — các path nối vào đều bắt đầu bằng "/" (tránh URL dạng "https://x.vn//api") */
const stripTrailingSlash = (url: string): string => url.replace(/\/+$/, '');

type RuntimeConfigKey =
  | 'REACT_APP_API_DOMAIN'
  | 'REACT_APP_WS_URL'
  | 'REACT_APP_ALLOWED_DOMAINS'
  | 'REACT_APP_USER_API_DOMAIN'
  | 'REACT_APP_COMPONENT_API_DOMAIN'
  | 'REACT_APP_ENV'
  | 'REACT_APP_SERVICE_PREFIX'
  | 'REACT_APP_DEFAULT_LANG';

/** Host môi trường dev — dùng config cố định bên dưới, không phụ thuộc config.js/configmap */
const DEV_HOSTNAMES = ['chatbot-dev.tendoo.vn'];

const DEV_RUNTIME_CONFIG: Partial<Record<RuntimeConfigKey, string>> = {
  REACT_APP_ENV: 'development',
  REACT_APP_API_DOMAIN: 'https://apiv3-dev.tendoo.vn',
  REACT_APP_WS_URL: 'wss://apiv3-dev.tendoo.vn',
  REACT_APP_ALLOWED_DOMAINS:
    'app-redesign.myshopapp.cloud,app-stg-v2.myshopapp.cloud,app-new.myshopapp.cloud,seller-v3.tendoo.vn,chatbot-dev.tendoo.vn,localhost:3000,app-stg-v2.myshopapp.cloud,localhost:3001,localhost:3000,127.0.0.1:3001',
  REACT_APP_USER_API_DOMAIN: 'https://apiv3-dev.tendoo.vn',
  REACT_APP_COMPONENT_API_DOMAIN: 'https://apiv3.tendoo.vn',
};

const isDevHost = DEV_HOSTNAMES.includes(window.location.hostname);

/** Ưu tiên config dev (nếu đang chạy trên host dev), sau đó tới window.* từ config.js */
const readRuntimeConfig = (key: RuntimeConfigKey): string | undefined =>
  (isDevHost ? DEV_RUNTIME_CONFIG[key] : undefined) ?? window[key];

const REACT_APP_API_DOMAIN = stripTrailingSlash(
  readRuntimeConfig('REACT_APP_API_DOMAIN') || process.env.REACT_APP_API_DOMAIN || '');
const REACT_APP_WS_URL = stripTrailingSlash(
  readRuntimeConfig('REACT_APP_WS_URL') || process.env.REACT_APP_WS_URL || '');
const REACT_APP_ALLOWED_DOMAINS =
  readRuntimeConfig('REACT_APP_ALLOWED_DOMAINS') || process.env.REACT_APP_ALLOWED_DOMAINS || '';
const REACT_APP_USER_API_DOMAIN = stripTrailingSlash(
  readRuntimeConfig('REACT_APP_USER_API_DOMAIN') || process.env.REACT_APP_USER_API_DOMAIN || '');
const REACT_APP_COMPONENT_API_DOMAIN = stripTrailingSlash(
  readRuntimeConfig('REACT_APP_COMPONENT_API_DOMAIN') ||
  process.env.REACT_APP_COMPONENT_API_DOMAIN ||
  '');
const REACT_APP_ENV =
  readRuntimeConfig('REACT_APP_ENV') || process.env.REACT_APP_ENV || 'development';
const REACT_APP_SERVICE_PREFIX =
  readRuntimeConfig('REACT_APP_SERVICE_PREFIX') ?? process.env.REACT_APP_SERVICE_PREFIX ?? '';
/** Dev only: token mock, được nạp vào sessionStorage khi chưa có token từ host app */
const REACT_APP_MOCK_TOKEN =
  process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_MOCK_TOKEN || '' : '';
const REACT_APP_DEFAULT_LANG =
  readRuntimeConfig('REACT_APP_DEFAULT_LANG') || process.env.REACT_APP_DEFAULT_LANG || 'vi';

export {
    REACT_APP_API_DOMAIN,
    REACT_APP_WS_URL,
    REACT_APP_ALLOWED_DOMAINS,
    REACT_APP_USER_API_DOMAIN,
    REACT_APP_COMPONENT_API_DOMAIN,
    REACT_APP_ENV,
    REACT_APP_SERVICE_PREFIX,
    REACT_APP_DEFAULT_LANG,
    REACT_APP_MOCK_TOKEN,
};